module.exports = __webpack_public_path__ + "4894be7e2dcfb74da720ee45acd362b9.pdf";